import { render, staticRenderFns } from "./AssemblyInventory.vue?vue&type=template&id=f0f695dc&"
import script from "./AssemblyInventory.vue?vue&type=script&lang=js&"
export * from "./AssemblyInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports